export function remapLogicOnUnshift (logicProperties) {
  if (!Array.isArray(logicProperties)) return logicProperties
  return logicProperties.map(rule => ({ ...rule, index: rule.index + 1 }))
}

export function remapLogicOnRemove (logicProperties, index) {
  if (!Array.isArray(logicProperties)) return logicProperties
  return logicProperties
    .filter(rule => rule.index !== index)
    .map(rule => rule.index > index ? { ...rule, index: rule.index - 1 } : rule)
}

export function upsertLogicRule (logicProperties, rule) {
  const list = Array.isArray(logicProperties) ? logicProperties : []
  const exists = list.some(item => item.index === rule.index)
  if (exists) {
    return list.map(item => item.index === rule.index ? { ...item, ...rule } : item)
  }
  return [...list, { ...rule }]
}
